var map = {
	"./Assets/lush.svg": 59,
	"./Assets/plate.svg": 42,
	"./Assets/thin.svg": 60,
	"./Exclude.svg": 38,
	"./Logo.svg": 49,
	"./account.svg": 48,
	"./arrow-left.svg": 28,
	"./check.svg": 47,
	"./close.svg": 37,
	"./delivery.svg": 98,
	"./error.svg": 99,
	"./exit.svg": 100,
	"./logout.svg": 29,
	"./mastercard.svg": 36,
	"./pizza.svg": 101,
	"./plus.svg": 102,
	"./repeat.svg": 103,
	"./success.svg": 53,
	"./title1.svg": 50,
	"./title2.svg": 51,
	"./visa.svg": 52
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97;